import Builder, { initialValues as builderInitialValues } from './Builder';
import Player from './Player';

export default {
    handle: 'riskFactors',
    label: 'Risk Factors',
    builderInitialValues,
    builder: Builder,
    player: Player,
};
